import Spinner from './Spinner'
import './Spinner.sass'

export default Spinner
